/***Dependencies */
import React from "react";

/**Components */
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Loader } from "../components/Loader";

/**Styles */

import { Col, Row } from "react-bootstrap";
import {
  Currency,
  FormatDate,
  FormatHours,
  FormatPhoneNumber,
} from "../helpers";

/**
 * Componente principal que muestra el banner con carrusel, inputs de búsqueda y selector de habitaciones.
 * @param {array} imgsBanner - Arreglo de objetos con propiedades "image" que contienen la ruta de
 *                              las imágenes del carrusel.
 * @param {boolean} showSearch - Indica si se muestra el formulario de búsqueda o no.
 * @returns {React.Component} - Componente principal con el banner y los inputs de búsqueda.
 */
export const ReservaConfirmada = ({
  arrReserva,
  reserva,
  arrReservaInfo,
  showLoader,
}) => {
  return (
    <>
      <Row className="justify-content-center">
        {showLoader && <Loader />}
        <Col lg={12} className="d-flex justify-content-center">
          <img
            src={`https://panel.marzahtravel.com/assets/img/logoHeader.png`}
            alt=""
            className="h-auto"
            width={180}
          />
        </Col>
        <Col lg={12}>
          <h1 className="text-center">
            Reservación Confirmada <br />{" "}
            <span style={{ fontSize: "30px" }}>
              Clave de confirmación: MTL-{reserva?.idReserva}{" "}
            </span>
          </h1>
        </Col>
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #1763af",
          }}
        />
        {arrReservaInfo?.producto_propio_reserva?.length > 0 && (
          <>
            <Col lg={12} className="mt-3 text-center">
              <h4 style={{ fontSize: "25px" }}>Datos de la oferta</h4>
              <Row className="justify-content-center">
                <Col
                  style={{ borderRight: "1px solid black", textAlign: "end" }}
                  lg={6}
                >
                  <p style={{ fontSize: "17px" }}>Nombre</p>
                  <p style={{ fontSize: "17px" }}>Noches</p>
                  <p style={{ fontSize: "17px" }}>Total de personas</p>
                </Col>
                <Col lg={6} className="text-start">
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.producto_propio_reserva?.[0]?.desc_corta}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.producto_propio_reserva?.[0]?.noches}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.producto_propio_reserva?.[0]?.num_personas}
                  </p>
                </Col>
              </Row>
            </Col>
            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
            <Col lg={12} className="mt-3 text-center">
              <h4 style={{ fontSize: "25px" }}>Datos de la reservacion</h4>
              <Row className="justify-content-center">
                <Col
                  style={{ borderRight: "1px solid black", textAlign: "end" }}
                  lg={6}
                >
                  <p style={{ fontSize: "17px" }}>Titular de reservación</p>
                  <p style={{ fontSize: "17px" }}>Número de reservación</p>
                  <p style={{ fontSize: "17px" }}>Total Pago</p>
                </Col>
                <Col lg={6} className="text-start">
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.reserva?.apellido_titular}{" "}
                    {arrReservaInfo?.reserva?.nombre_titular}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.pago?.id_reserva}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {Currency(arrReservaInfo?.pago?.monto_total) + " MXN"}
                  </p>
                </Col>
              </Row>
            </Col>

            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
            <Col lg={12} className="mt-3 text-center">
              <div>
                <h4 style={{ fontSize: "25px" }}>Descripcion de la oferta</h4>

                <p
                  style={{
                    textAlign: "justify",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      arrReservaInfo?.producto_propio_reserva[0]?.desc_larga,
                  }}
                />
              </div>
              <div>
                <h4 style={{ fontSize: "25px" }}>Detalles de la oferta</h4>
                <h6>Incluye</h6>
                <p
                  style={{
                    textAlign: "start",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: arrReservaInfo?.producto_propio_reserva[0]?.incluye,
                  }}
                />
              </div>
              <div>
                <h6>No Incluye</h6>
                <p
                  style={{
                    textAlign: "start",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      arrReservaInfo?.producto_propio_reserva[0]?.no_incluye,
                  }}
                />
              </div>
              <div>
                <h6>Temporada</h6>
                <p
                  style={{
                    textAlign: "justify",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      arrReservaInfo?.producto_propio_reserva[0]?.temporada,
                  }}
                />
              </div>
            </Col>
          </>
        )}
        {arrReservaInfo?.habitaciones_reserva?.length > 0 && (
          <>
            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
            <Col lg={12} className="mt-3 text-center">
              <h4 style={{ fontSize: "25px" }}>Datos del Hotel</h4>
              <Row className="justify-content-center">
                <Col
                  style={{ borderRight: "1px solid black", textAlign: "end" }}
                  lg={6}
                >
                  <p style={{ fontSize: "17px" }}>Hotel</p>
                  <p style={{ fontSize: "17px" }}>Categoría</p>
                  <p style={{ fontSize: "17px" }}>Dirección</p>
                </Col>
                <Col lg={6} className="text-start">
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.hotel?.nombre}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.habitaciones_reserva?.[0]?.categoria}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.hotel?.direccion}
                  </p>
                </Col>
              </Row>
            </Col>
            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
            <Col lg={12} className="mt-3 text-center">
              <h4 style={{ fontSize: "25px" }}>
                Datos de reservación hotelera
              </h4>
              <Row className="justify-content-center">
                <Col
                  style={{ borderRight: "1px solid black", textAlign: "end" }}
                  lg={6}
                >
                  <p style={{ fontSize: "17px" }}>Titular de reservación</p>
                  {/* <p style={{fontSize: "17px"}}>Número de reservación</p> */}
                  <p style={{ fontSize: "17px" }}>Total Pago</p>
                </Col>
                <Col lg={6} className="text-start">
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.reserva?.apellido_titular}
                  </p>
                  {/* <p style={{fontSize: "17px"}}>{arrReservaInfo?.habitaciones_reserva?.[0]?.id_res_api}</p> */}
                  <p style={{ fontSize: "17px" }}>
                    {Currency(arrReservaInfo?.pago?.monto_total) + " MXN"}
                  </p>
                </Col>
              </Row>
            </Col>
            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
            {arrReservaInfo.habitaciones_reserva?.map((reserva, index) => (
              <>
                <Col lg={12} key={index + 1} className="mt-3 text-center">
                  <h4 style={{ fontSize: "25px" }}>
                    Datos de habitación {index + 1}
                  </h4>
                  <Row className="justify-content-center">
                    <Col
                      style={{
                        borderRight: "1px solid black",
                        textAlign: "end",
                      }}
                      lg={3}
                    >
                      <p style={{ fontSize: "17px" }}>
                        Responsable de habitación
                      </p>
                      <p style={{ fontSize: "17px" }}>Número de reservación</p>
                      <p style={{ fontSize: "17px" }}>Adultos</p>
                      <p style={{ fontSize: "17px" }}>Niños</p>
                      <p style={{ fontSize: "17px" }}>Tipo de habitación</p>
                      <p style={{ fontSize: "17px" }}>Plan alimentación</p>
                      <p style={{ fontSize: "17px" }}>Fecha reservada</p>
                    </Col>
                    <Col lg={3} className="text-start">
                      <p style={{ fontSize: "17px" }}>
                        {reserva?.nombre_responsable}{" "}
                        {reserva?.apellido_responsable}
                      </p>
                      <p style={{ fontSize: "17px" }}>{reserva?.id_res_api}</p>
                      <p style={{ fontSize: "17px" }}>{reserva?.num_adultos}</p>
                      <p style={{ fontSize: "17px" }}>{reserva?.num_menores}</p>
                      <p style={{ fontSize: "17px" }}>{reserva?.alojamiento}</p>
                      <p style={{ fontSize: "17px" }}>
                        {reserva?.plan_alimentos}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        Del {FormatDate(reserva?.checkin)} al{" "}
                        {FormatDate(reserva?.checkout)}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={12}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: reserva?.politicas_cancelacion,
                    }}
                    style={{ fontSize: "17px" }}
                  />
                  <p style={{ fontSize: "17px" }}>Información importante</p>
                  <p style={{ fontSize: "17px" }}>
                    {
                      arrReserva?.hospedaje?.find(
                        (id) => id?.nombreHab == reserva?.alojamiento
                      )?.rateComments
                    }
                  </p>
                </Col>
              </>
            ))}
            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
          </>
        )}
        {arrReservaInfo?.actividad_reserva?.length > 0 && (
          <>
            <Col lg={12} className="mt-3 text-center">
              <h4 style={{ fontSize: "25px" }}>
                Datos de reservación de actividades
              </h4>

              <Row className="justify-content-center">
                <Col
                  style={{ borderRight: "1px solid black", textAlign: "end" }}
                  lg={6}
                >
                  <p style={{ fontSize: "17px" }}>Titular de la reservación</p>
                  <p style={{ fontSize: "17px" }}>Total Pago</p>
                </Col>
                <Col lg={6} className="text-start">
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.reserva?.nombre_titular +
                      " " +
                      arrReservaInfo?.reserva.apellido_titular}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {Currency(
                      arrReservaInfo?.actividad_reserva[0]?.monto_total
                    ) + " MXN"}
                  </p>
                </Col>
              </Row>
            </Col>
            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
            {arrReservaInfo.actividad_reserva?.map((reservaAct, index) => (
              <>
                <Col lg={12} key={index + 1} className="mt-3 text-center">
                  <h4 style={{ fontSize: "25px" }}>
                    Datos de actividad {reservaAct?.actividad}
                  </h4>
                  <Row className="justify-content-center">
                    <Col
                      style={{
                        borderRight: "1px solid black",
                        textAlign: "end",
                      }}
                      lg={6}
                    >
                      <p style={{ fontSize: "17px" }}>
                        Responsable de actividad
                      </p>
                      <p style={{ fontSize: "17px" }}>Adultos</p>
                      <p style={{ fontSize: "17px" }}>Niños</p>
                      <p style={{ fontSize: "17px" }}>Modalidad</p>
                      <p style={{ fontSize: "17px" }}>Número de referencia</p>
                      <p style={{ fontSize: "17px" }}>Fecha reservada</p>
                    </Col>
                    <Col lg={6} className="text-start">
                      <p style={{ fontSize: "17px" }}>
                        {reservaAct?.nombre_responsable}{" "}
                        {reservaAct?.apellido_responsable}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {reservaAct?.num_adultos}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {reservaAct?.num_menores}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {reservaAct?.modalidad}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {reservaAct?.id_res_api}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {FormatDate(reservaAct?.fecha_actividad)}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={12}>
                  {reservaAct?.texto_preguntas && (
                    <p style={{ fontSize: "17px" }}>
                      {reservaAct?.texto_preguntas}
                    </p>
                  )}
                  <br />
                  <p style={{ fontSize: "17px" }}>
                    Política de cancelación: A partir de las siguientes fechas y
                    horas, se aplicará una penalidad:
                  </p>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: reservaAct?.politicas_cancelacion,
                    }}
                    style={{ fontSize: "17px", margin: "0" }}
                  />
                  <p style={{ fontSize: "17px", fontWeight: "bold" }}>
                    Fecha y hora calculados en base a la hora local del destino.
                  </p>
                  <p
                    style={{
                      fontSize: "17px",
                      backgroundColor: "#1763af",
                      color: "white",
                      padding: "15px",
                      textAlign: "center",
                    }}
                  >
                    Asegúrese de leer las observaciones para hacer uso de la
                    actividad
                  </p>
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Observaciones
                  </p>
                  <p>{arrReserva?.actividades[0]?.observaciones}</p>
                </Col>
              </>
            ))}
            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
          </>
        )}
        {arrReservaInfo?.traslado_reserva?.length > 0 && (
          <>
            <Col lg={12} className="mt-3 text-center">
              <h4 style={{ fontSize: "25px" }}>Datos de la reservación</h4>
              <Row className="justify-content-center">
                <Col
                  style={{ borderRight: "1px solid black", textAlign: "end" }}
                  lg={6}
                >
                  <p style={{ fontSize: "17px" }}>Nombre Titular</p>
                  <p style={{ fontSize: "17px" }}>Apellido Titular</p>
                  <p style={{ fontSize: "17px" }}>Email Titular</p>
                </Col>
                <Col lg={6} className="text-start">
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.reserva?.nombre_titular}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.reserva?.apellido_titular}
                  </p>
                  <p style={{ fontSize: "17px" }}>
                    {arrReservaInfo?.reserva?.email_titular}
                  </p>
                </Col>
              </Row>
            </Col>
            <hr
              style={{
                width: "70%",
                margin: "0 auto",
                border: "3px solid #1763af",
              }}
              className="my-3"
            />
            {arrReservaInfo.traslado_reserva?.map((traslado, index) => (
              <>
                <Col lg={12} key={index + 1} className="mt-3 text-center">
                  <h4 style={{ fontSize: "25px" }}>
                    Datos del Traslado de {traslado?.tipo_traslado}
                  </h4>
                  <Row className="justify-content-center">
                    <Col
                      style={{
                        borderRight: "1px solid black",
                        textAlign: "end",
                      }}
                      lg={6}
                    >
                      <p style={{ fontSize: "17px" }}>
                        Total del Traslado de {traslado?.tipo_traslado}
                      </p>
                      <p style={{ fontSize: "17px" }}>Salida desde</p>
                      <p style={{ fontSize: "17px" }}>Llegada hacia</p>
                      <p style={{ fontSize: "17px" }}>
                        Fecha de {traslado?.tipo_traslado}
                      </p>
                      <p style={{ fontSize: "17px" }}>Adultos</p>
                      <p style={{ fontSize: "17px" }}>Menores</p>
                      <p style={{ fontSize: "17px" }}>Infantes</p>
                    </Col>
                    <Col lg={6} className="text-start">
                      <p style={{ fontSize: "17px" }}>
                        {Currency(traslado?.monto_total) + " MXN"}
                      </p>
                      <p style={{ fontSize: "17px" }}>{traslado?.origen}</p>
                      <p style={{ fontSize: "17px" }}>{traslado?.destino}</p>
                      <p style={{ fontSize: "17px" }}>
                        {traslado?.fecha_viaje != null
                          ? traslado?.fecha_viaje
                          : "N/A"}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {traslado?.num_adultos}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {traslado?.num_menores}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {traslado?.num_infantes}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={12} key={index + 1} className="mt-3 text-center">
                  <h4 style={{ fontSize: "25px" }}>
                    Datos del Vehículo de {traslado?.tipo_traslado}
                  </h4>
                  <Row className="justify-content-center">
                    <Col
                      style={{
                        borderRight: "1px solid black",
                        textAlign: "end",
                      }}
                      lg={6}
                    >
                      <p style={{ fontSize: "17px" }}>Tipo de Traslado</p>
                      <p style={{ fontSize: "17px" }}>Tipo de Vehículo</p>
                      <p style={{ fontSize: "17px" }}>Tipo de Viaje</p>
                      <p style={{ fontSize: "17px" }}>Número de emergencia</p>
                    </Col>
                    <Col lg={6} className="text-start">
                      <p style={{ fontSize: "17px" }}>
                        {traslado?.tipo_traslado}
                      </p>
                      <p style={{ fontSize: "17px" }}>
                        {traslado?.tipo_vehiculo}
                      </p>
                      <p style={{ fontSize: "17px" }}>{traslado?.tipo_viaje}</p>
                      <p style={{ fontSize: "17px" }}>
                        {FormatPhoneNumber(traslado?.numero_emergencia)}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <hr
                  style={{
                    width: "70%",
                    margin: "0 auto",
                    border: "3px solid #1763af",
                  }}
                  className="my-3"
                />
                <Col lg={12}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: traslado?.politicas_cancelacion,
                    }}
                    style={{ fontSize: "17px" }}
                  />
                  <p style={{ fontSize: "17px", fontWeight: "bold" }}>
                    Fecha y hora calculados en base a la hora local del destino.
                  </p>
                  {arrReserva?.traslados && (
                    <>
                      <p style={{ fontSize: "17px" }}>Información importante</p>

                      <p
                        key={index + 1}
                        style={{ fontSize: "17px", textAlign: "justify" }}
                      >
                        {
                          arrReserva?.traslados?.find(
                            (trasladoSession) =>
                              trasladoSession?.fechaViaje ===
                              traslado?.fecha_viaje?.split(" ")[0]
                          )?.observacionesTraslados
                        }
                      </p>
                    </>
                  )}
                </Col>
              </>
            ))}
          </>
        )}
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #1763af",
          }}
          className="my-3"
        />
        <Col lg={12} className="mt-3 text-center">
          <h4>Total de la reservación</h4>
          <Row className="justify-content-center">
            <Col
              style={{ borderRight: "1px solid black", textAlign: "end" }}
              lg={6}
            >
              {arrReservaInfo.codigo_pais === "MX" && (
                <>
                  <p style={{ fontSize: "17px" }}>Subtotal</p>
                  <p style={{ fontSize: "17px" }}>Impuestos</p>
                </>
              )}
              <p style={{ fontSize: "17px" }}>
                Total {arrReservaInfo.codigo_pais === "MX" && "con Impuestos"}
              </p>
              {arrReservaInfo?.pago?.monto_descuento != null && (
                <strong style={{ fontSize: "17px" }}>
                  Total (cupón aplicado)
                </strong>
              )}
            </Col>
            {arrReservaInfo.codigo_pais === "MX" ? (
              <Col lg={6} className="text-start">
                <p style={{ fontSize: "17px" }}>
                  {Currency(arrReservaInfo?.pago?.monto_sin_iva) + " MXN"}
                </p>
                <p style={{ fontSize: "17px" }}>
                  {Currency(arrReservaInfo?.pago?.iva_monto) + " MXN"}
                </p>
                <p style={{ fontSize: "17px" }}>
                  {Currency(arrReservaInfo?.pago?.monto_total) + " MXN"}
                </p>
                {arrReservaInfo?.pago?.monto_descuento != null && (
                  <p style={{ fontSize: "17px" }}>
                    {Currency(arrReservaInfo?.pago?.monto_descuento) + " MXN"}
                  </p>
                )}
              </Col>
            ) : (
              <Col lg={6} className="text-start">
                <p style={{ fontSize: "17px" }}>
                  {Currency(arrReservaInfo?.pago?.monto_total)}
                </p>
              </Col>
            )}
          </Row>
        </Col>
        <hr
          style={{
            width: "70%",
            margin: "0 auto",
            border: "3px solid #1763af",
          }}
          className="my-3"
        />
        <Col lg={12}>
          <p style={{ textAlign: "justify", fontSize: "17px" }}>
            No olvides presentar este correo junto con la identificación (INE,
            pasaporte) en el momento de ingreso a tu hotel.
          </p>

          <p style={{ textAlign: "justify", fontSize: "17px" }}>
            Información importante
            <br />
            Este correo electrónico es tu comprobante de pago o transacción
            bancaria. No es válido para el uso del servicio, recibirás por
            correo electrónico tu cupón o itinerario en un próximo correo
            electrónico. No dudes en ponerte en contacto ante cualquier duda o
            aclaración.
          </p>
          <p style={{ textAlign: "justify", fontSize: "17px" }}>
            En Marzah Travel estamos comprometidos con tu seguridad. Por ello,
            te informamos que de manera aleatoria nuestro Departamento de
            Protección de Datos Personales, realiza una validación adicional y
            podrá solicitar documentos que comprueben que eres el titular de la
            reserva y/o la compra es autorizada por el titular de la forma de
            pago que elegiste. En caso de no proveerla, tu reserva puede estar
            sujeta a la cancelación.
            <br />
            <br />
            Si tienes dudas de tu reservación o deseas realizar algún cambio,
            comunícate al <strong>998 218 9740</strong> y uno de nuestros
            ejecutivos te podrá asesorar.
            <br />
            <br />
            Después de realizar tu pago deberás confirmarlo enviándolo al
            correo&nbsp;
            <a href="mailto:info@marzahtravel.com">
              info@marzahtravel.com
            </a>{" "}
            {arrReservaInfo?.habitaciones_reserva?.length > 0 &&
              "si no se confirma el pago en las siguientes 24 horas deberá confirmar que la habitación está disponible generando nuevamente tu reservación."}
          </p>
          <p style={{ textAlign: "center", fontSize: "17px" }}>
            © Marzah Travel. Todos los derechos reservados.
          </p>
        </Col>
      </Row>
    </>
  );
};
